import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error('Instagram ErrorBoundary caught', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="instagram-error">
          <div className="instagram-error-title">Instagram feed unavailable</div>
          <div className="instagram-error-text">We couldn't load the Instagram feed right now. Please try again later.</div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
